import { GigyaAccount } from "../interfaces/GigyaAccount";
import { useState, useEffect } from "react";
import useBrowserMode from './useBrowserMode';
import { LoginGigyaInterface } from "../interfaces/LoginGigyaInterface";

declare var gigya: any;

const REASON = {
   CANCELED: 'canceled'
}

const useLoginGigya = (): LoginGigyaInterface => {

   const [gigyaAccount, setGigyaAccount] = useState<GigyaAccount>();
   const { isBrowser, document } = useBrowserMode();


   const showScreen = (startScreen: string, screenSet:string ) => {
      if(isBrowser) {
         const querySelector = document.querySelector('body');
         if( querySelector?.classList.contains('freeze-page') ) {
            querySelector?.classList.add('freeze-gigya')
         }
      }
      gigya.accounts.showScreenSet({
         screenSet: screenSet,
         startScreen: startScreen,
         onHide: getUSerInfo,
         deviceType: 'auto',
      });
   }

   const getUSerInfo = (response: any) => {
      if(isBrowser) {
         const querySelector = document.querySelector('body');
         querySelector?.classList.remove('freeze-gigya')
      }
      if (REASON.CANCELED !== response?.reason) {
         gigya.accounts.getAccountInfo({ callback: getData })
      } else {
         console.log('REASON =>', response?.reason);
      }
   }

   const getData = (res: GigyaAccount) => {
      if (res.data && res.data.userVerification) {
         setGigyaAccount(res);
      } else {
         setGigyaAccount(undefined);
      }
   }

   const getLogout = ( response:any ) => {
      if ( response.errorCode == 0 ) {               	 
         gigya.accounts.getAccountInfo({ callback: getData });
      } else {
         alert('Error :' + response.errorMessage);  
      }
   }

   const login = () => {
      showScreen('gigya-login-screen', 'POC-RegistrationLogin');
   }

   const updateProfile = () => {
      showScreen('gigya-my-account-screen', 'Comfama-ProfileUpdate');
   }

   const register = () => {
      showScreen('gigya-register-screen', 'POC-RegistrationLogin');
   }

   const logout = () => {
      gigya.accounts.logout({ callback: getLogout });
   }

   useEffect( () => {
      if( typeof gigya === 'object' ) {
         gigya.accounts.getAccountInfo({ callback: getData })
      }
   }, [] )

   return { login, register, logout, gigyaAccount, updateProfile }
}

export default useLoginGigya;
